import React from 'react'
import { ControlledTextInput } from 'transfix-form/components'
import { ModalBase, IModalBaseProps, MODAL_TYPES } from 'transfix-ui/components/Modals'
import { Box } from 'transfix-ui/core'
import { IParserSchema } from './ParserSchema'
import { createParser, updateParser } from './api'
import { parserRequest, Parser } from './types'
import { useSaveParserForm } from './useSaveParserForm'

interface ISaveParserModalProps extends Omit<IModalBaseProps, 'modalType'> {
  onClose: () => void
  onSuccess: () => void
  selectedParser?: Parser
}

export const SaveParserModal = ({
  onClose,
  onSuccess,
  selectedParser,
  ...props
}: ISaveParserModalProps) => {
  const methods = useSaveParserForm()

  const { control, errors, handleSubmit } = methods

  const saveParser = async (formParams: IParserSchema) => {
    const body: parserRequest = {
      configurable_parser: {
        name: formParams.name,
      },
    }
    if (selectedParser) {
      await updateParser(body, selectedParser.id)
    } else {
      await createParser(body)
    }
    onClose()
    onSuccess()
  }

  const saveHandler = handleSubmit(saveParser)

  const actions: IModalBaseProps['actions'] = [
    {
      label: 'Save',
      action: saveHandler,
      type: 'confirm',
      dataTest: 'confirm-button',
    },
    {
      label: 'Cancel',
      type: 'dismiss',
      dataTest: 'cancel-button',
    },
  ]

  return (
    <ModalBase
      onClose={onClose}
      dataTest='SaveParserModal'
      modalType={MODAL_TYPES.form}
      size={2}
      title={selectedParser ? 'Edit Parser Name' : 'Create New Parser'}
      open
      closeOnBackdropClick
      actions={actions}
      {...props}>
      <Box mb={2}>
        <ControlledTextInput
          control={control}
          name='name'
          TextInputProps={{
            label: 'Parser Name',
            placeholder: selectedParser?.name || 'Name',
            validationMessage: errors.name?.message,
          }}
        />
      </Box>
    </ModalBase>
  )
}
